import { NewLeadModal } from './NewLeadModal';
import { ToastContainer } from '../ui/Toast';

/**
 * GlobalModals - Renders all globally accessible modals and the toast container.
 *
 * This component should be rendered once at the app root level, inside the
 * GlobalModalProvider context. It handles:
 *
 * - NewLeadModal (Cmd+N or Ctrl+N to open)
 * - Toast notifications
 * - Future: Command palette, quick search, etc.
 *
 * All modals use React portals to render at the document body level,
 * ensuring proper z-index stacking and avoiding CSS containment issues.
 */
export function GlobalModals() {
  return (
    <>
      <NewLeadModal />
      <ToastContainer />
    </>
  );
}
